module.exports = __webpack_public_path__ + "static/media/asian.edead8d7.png";